import { RefreshCw, Wifi, WifiOff } from "lucide-react";

function NetworkErrorModal({
  show,
  onLogin,
  onRetry,
  onCancel,
  errorType,
  isRefunding,
  isUnauthorized,
}) {
  if (!show) return null;

  const getErrorMessage = () => {
    switch (errorType) {
      case "network":
        return "Network connection lost. Please check your internet connection.";
      case "api":
        return "Server error occurred. Unable to process your request.";
      case "timeout":
        return "Request timed out. Please try again.";
      default:
        return "Something went wrong. Please try again.";
    }
  };

  const getErrorIcon = () => {
    switch (errorType) {
      case "network":
        return <WifiOff size={48} color="#dc3545" />;
      default:
        return <WifiOff size={48} color="#dc3545" />;
    }
  };

  return (
    <div className="modal-overlay modal-overlay-network-error">
      <div className="modal-content modal-content-network-error">
        {isUnauthorized ? (
          <div style={{ marginBottom: "20px", color: "#666" }}>
            Session Expired, Please login again.
          </div>
        ) : (
          <>
            <div style={{ marginBottom: "20px" }}>{getErrorIcon()}</div>
            <h3 className="connection-error-text">Connection Error</h3>
            <p className="error-msg-text">{getErrorMessage()}</p>
          </>
        )}

        {isRefunding && (
          <div className="refund-outer-div">
            <div className="d-center mb-2">
              <RefreshCw
                size={16}
                className="animate-spin"
                style={{ marginRight: "8px" }}
              />
              <span style={{ color: "#28a745", fontWeight: "500" }}>
                Processing Refund...
              </span>
            </div>
            <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>
              Your payment is being refunded automatically.
            </p>
          </div>
        )}

        <div className="d-center gap-10px">
          <button
            onClick={
              isUnauthorized
                ? () => {
                    onLogin();
                    onCancel();
                  }
                : onRetry
            }
            disabled={isRefunding}
            className="retry-button-network-error"
          >
            {isUnauthorized ? (
              "Login"
            ) : (
              <>
                <Wifi size={16} />
                Try Again
              </>
            )}
          </button>

          <button onClick={onCancel} className="cancel-button-network-error">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default NetworkErrorModal;
